import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_GSC_GROUP_RANKING_URL } from '../../constants/apiUrls';
import { PaginatedData } from '../../models/List';
import { ApiPathParam } from '../../models/SearchParamSchema';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PostRankingDetailsResponse {
  indexNo?: string;
  uniFinPassport: string;
  candidateName?: string;
  prelimGradeMarks?: string;
  affected: boolean;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: PaginatedData<PostRankingDetailsResponse>) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostGroupRankingDetails = ({ uuid, onSuccess, onError }: Input) => {
  const postGroupRankingDetails = async (apiPathParam: ApiPathParam) => {
    const res = await axiosClient.post<PaginatedData<PostRankingDetailsResponse>>(
      POST_GSC_GROUP_RANKING_URL(uuid, apiPathParam)
    );
    return res.data;
  };
  return useCustomMutation(postGroupRankingDetails, {
    onSuccess,
    onError,
  });
};
